import {CLOSE_CONFIRMATION_MODAL, OPEN_CONFIRMATION_MODAL} from "./ConfirmationModalActions";

export default function reducer(state = {
    text: '',
    open: false,
    callback: null
}, action) {
    switch (action.type) {
        case OPEN_CONFIRMATION_MODAL :
            return {...state, open: true, ...action.payload};
        case CLOSE_CONFIRMATION_MODAL :
            return {...state, open: false};
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/components/confirmation-modal/ConfirmationModalReducer.js